import { makeStyles, tokens } from '@fluentui/react-components';

export const useAlertBannerFormFlyoutStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    paddingTop: '8px',
  },
  fieldLabel: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    marginBottom: '8px',
  },
  requiredMarker: {
    color: tokens.colorPaletteRedForeground1,
    marginLeft: '2px',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  nestedField: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    marginLeft: '8px',
    marginTop: '8px',
    marginBottom: '8px',
  },
  angleIndicator: {
    width: '12px',
    height: '14px',
    marginTop: '2px',
    borderLeft: `1px solid ${tokens.colorNeutralStroke2}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    borderBottomLeftRadius: '2px',
    flexShrink: 0,
  },
  nestedFieldContent: {
    flex: 1,
    minWidth: 0,
  },
  nestedFieldLabel: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    marginBottom: '6px',
  },
  checkboxRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: '0',
    rowGap: '4px',
  },
  featureDropdown: {
    maxWidth: '250px',
  },
  dateInput: {
    maxWidth: '250px',
  },
  hint: {
    display: 'block',
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    marginTop: '-2px',
    marginBottom: '6px',
  },
  audienceError: {
    display: 'block',
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorPaletteRedForeground1,
    marginTop: '-4px',
    marginBottom: '8px',
  },
  dateSpanWarning: {
    marginTop: '8px',
  },
});
